import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Container, Spinner, Alert } from 'reactstrap';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import CommonDataTable from '../../common/DataTable';
import { getQuestionColumns } from '../../Components/Common/columns/Question';
import { bulkDeleteQuestion, deleteQuestion, getQuestionPage } from '../../slices/thunks';
import { setFilterParams } from '../../slices/question/reducer';
import { Button } from "reactstrap";
import { useNavigate } from "react-router-dom";

const QuestionList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const { questions, loading, error, filterParams } = useSelector(
    (state) =>
      state.quizeQuestion || {
        questions: { data: [] },
        filterParams: { currentPage: 1, perPage: 20 },
      }
  );

  // Fix data structure access
  const questionList = questions?.data?.data?.data || [];
  const totalCount = questions?.data?.data?.totalCount || 0;
  const currentPage = questions?.data?.data?.currentPage || 1;
  const totalPages = questions?.data?.data?.totalPages || 1;

  const [selectedRows, setSelectedRows] = useState([]);
  const [confirmOpenForId, setConfirmOpenForId] = useState();

  useEffect(() => {
    const params = filterParams || { currentPage: 1, perPage: 20 };
    dispatch(getQuestionPage(params));
  }, [dispatch, filterParams]);

  const handleDelete = useCallback(async (questionId) => {
    try {
      await dispatch(deleteQuestion({ id: questionId }));
      dispatch(getQuestionPage(filterParams));
    } catch (error) {
      console.error('Error deleting question:', error);
    }
  }, [dispatch, filterParams]);

  const handleBulkDelete = useCallback(async () => {
    const questionIds = selectedRows.map((row) => row.id);
    if (questionIds.length > 0) {
      try {
        await dispatch(bulkDeleteQuestion({ questionIds }));
        dispatch(getQuestionPage(filterParams));
        setSelectedRows([]);
      } catch (error) {
        console.error('Error in bulk delete:', error);
      }
    }
  }, [dispatch, selectedRows, filterParams]);

  const fetchData = useCallback((newFilterParams) => {
    // Update filter params in Redux state
    dispatch(setFilterParams(newFilterParams));
    // Fetch new data with updated params
    dispatch(getQuestionPage(newFilterParams));
  }, [dispatch]);

  const columns = getQuestionColumns({
    onDeleteClick: handleDelete,
    confirmOpenForId,
    setConfirmOpenForId,
  });

  const handleAddButtonClick = () => {
    navigate('/quize-question/add-form');
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Questions" pageTitle="Questions" />
        </Container>
      </div>
      <div className="table-container">
        {loading && (
          <div className="text-center">
            <Spinner color="primary" />
            <p>Loading questions...</p>
          </div>
        )}

        {error && (
          <Alert color="danger">
            <strong>Error:</strong> {error}
          </Alert>
        )}

        {!loading && !error && (
          <CommonDataTable
            from="question"
            data={questionList}
            totalRows={totalCount}
            loading={loading}
            showAddButton={true}
            addOnClickMethod={handleAddButtonClick}
            columns={columns}
            checkboxEnabled={false}
            bulkDelete={handleBulkDelete}
            selectedRows={selectedRows}
            bulkSelected={(rows) => setSelectedRows(rows)}
            searchEnable={false}
            filterParams={filterParams || { currentPage: 1, perPage: 20 }}
            fetchData={fetchData}
            showExportButton={false}
            exportFileName="question"
            currentPage={currentPage}
            totalPages={totalPages}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default QuestionList;
